export default "__VITE_ASSET__BochvsQk__"